const modals = document.querySelectorAll('.modal');
const modalToggles = document.querySelectorAll('[data-modal-toggle]');

//modalToggleHandler: get the attr "data-modal-toggle" and find the .modal with matching data-modal attribute

const closeModal = (modal) => {
    //if no modal is passed, close all modals
    if (!modal) {
        modals.forEach(modal => {
            modal.classList.remove('active');
        });
    }
    else {
        modal.classList.remove('active');
    }
    //remove active from all modal-toggles
    modalToggles.forEach(toggle => {
        toggle.classList.remove('active');
    });
    document.body.classList.remove('open-modal');

    document.body.removeAttribute('data-modal-open');

}

const modalToggleHandler = (e) => {
    e.stopPropagation();
    const modalToggle = e.target.closest('[data-modal-toggle]');
    const modalId = modalToggle.getAttribute('data-modal-toggle');
    const modal = document.querySelector(`.modal[data-modal="${modalId}"]`);
    console.log({modal, modalToggle});
    const isActive = modal.classList.contains('active');

     //remove active from all active modals
     document.querySelectorAll(".modal.active").forEach(m => {
        if (m !== modal) {
            m.classList.remove('active');
        }
    });

    modal.classList.toggle('active');
    modalToggle.classList.toggle('active');
    //also any other modal-toggle with same data-modal-toggle should be removed
    modalToggles.forEach(toggle => {
        if (toggle !== modalToggle) {
            toggle.classList.remove('active');
        }
    });
   
    //add open-modal attribute to body
    document.body.classList.toggle('open-modal');
    if(!isActive) {
        document.body.setAttribute('data-modal-open', modalId);
    } else {
        document.body.removeAttribute('data-modal-open');
    }
}

window.handlers = {
    modalToggleHandler
}

modalToggles.forEach(toggle => {
    toggle.addEventListener('click', modalToggleHandler);
});

//if user clicks "close-modal" class, find the containing .modal and close it
document.body.addEventListener('click', (e) => {
    console.log("click!",e.target.closest('.modal'));
    if (document.body.classList.contains("open-modal") && !e.target.closest('.modal')) {
        closeModal();
    }
    if (e.target.classList.contains('close-modal')) {
        const modal = e.target.closest('.modal');
        closeModal(modal);
    }
    //if we don't click inside a modal, close all modals
    
});

//on click escape, close all modals

document.body.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        closeModal();
    }
});

// // if user clicks outside of the modal, close it
// document.body.addEventListener('click', (e) => {
//     if (!e.target.closest('modal')) {
//         closeModal();
//     }
// });

window.toggleModal = (modalId) => {
    const modal = document.querySelector(`.modal[data-modal="${modalId}"]`);
    modal.classList.toggle('active');
    document.body.classList.toggle('open-modal');
    document.body.setAttribute('data-modal-open', modalId);
}

//if data-modal-open="cart" is set, turn it off on scroll and hide modal
document.body.addEventListener('wheel', (e) => {
    if (document.body.getAttribute('data-modal-open') === "cart") {
        console.log(e)
        closeModal();
    }
});